import Cookies from 'js-cookie';
import { MLML_LEAD_COOKIE_NAME } from 'constants/cookies';

/**
 * Reads the affiliate handle from the my-link-my-lead cookie.
 * Returns null if the cookie is absent or has no handle field.
 */
export function getHandleFromCookie(): string | null {
  try {
    const raw = Cookies.get(MLML_LEAD_COOKIE_NAME);
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data.handle ?? null;
  } catch {
    return null;
  }
}

/**
 * Appends /@handle to a URL path if a handle exists in the cookie.
 * Does not append if the path already contains a handle.
 */
export function appendHandleFromCookie(url: string): string {
  const handle = getHandleFromCookie();
  if (!handle) return url;
  if (url.includes('/@')) return url;
  return `${url}/@${handle}`;
}
